import { classNames } from '../../utils/style';
import { textBodyLarge, textTitle3 } from '../../styles/typography';

import { CardProps } from './';

const styleSolo = classNames('w-[527px] md:w-full lg:w-[750px]');
const styleOther = classNames('h-[428px]');
const styleMultiple = classNames(
  'w-[356px] lg:max-w-auto lg:w-[360px] xl:w-[400px] overflow-hidden',
);
const styleBlog = classNames('h-[515px] sm:h-[493px]  xl:h-[471px]');
const styleQuoteWithImg = classNames(
  'lg:h-[444px] lg:w-[750px]',
  'xl:w-[824px]',
);

export const applyCardStyle = (type: CardProps['type']) => {
  if (type === 'article' || type === 'quote')
    return classNames(styleOther, styleSolo, 'px-24 py-32 sm:px-40 sm:py-56');
  if (
    type === 'multipleArticles' ||
    type === 'multipleQuotes' ||
    type === 'form'
  )
    return classNames(
      styleOther,
      styleMultiple,
      'px-24 py-32 sm:px-40 sm:py-56',
    );
  if (type === 'multipleBlogs') return classNames(styleBlog, styleMultiple);

  return classNames(styleOther, styleMultiple);
};

export const applyQuoteWithImgStyle = (
  imagePosition: CardProps['imagePosition'],
  cardsBackgroundColor: boolean,
) =>
  classNames(
    styleQuoteWithImg,
    'p-24 md:p-40 h-full',
    cardsBackgroundColor && 'bg-neutral-1',
    imagePosition === 'right'
      ? 'flex-col sm:flex-row'
      : 'flex-col-reverse lg:flex-row-reverse',
  );

export const applyCardContentStyle = (type: CardProps['type']) => {
  if (type === 'quoteWithImg') return 'lg:w-1/2 my-auto';

  return 'flex flex-col';
};

export const applyLogoContentStyle = (type: CardProps['type']) => {
  if (type === 'quoteWithImg') return 'mb-16 h-32';

  return 'mb-24 h-48';
};

export const applyTextStyle = (type: CardProps['type']) => {
  if (type === 'quoteWithImg')
    return classNames('text-neutral-101 mb-24', textBodyLarge);
  if (type === 'form') return classNames('text-neutral-301', textBodyLarge);
  if (type === 'multipleArticles' || type === 'multipleQuotes')
    return classNames('text-neutral-301', textBodyLarge);

  return classNames('text-neutral-301', textTitle3);
};

export const applyCtaButtonStyle = (type: CardProps['type']) => {
  if (type === 'quoteWithImg') return 'mt-24 whitespace-break-spaces';
  if (type === 'multipleQuotes' || type === 'multipleArticles')
    return 'mt-auto self-start';

  return 'mt-auto sm:self-start';
};

export const animationImage = 'group-two-hover:scale-110';
export const transitionAnimation = 'transition-all duration-500';
